<div class="py-4 px-4">
  <mat-card-header class="flex align-items-center">
    <shared-title>{{ this.data ? 'Editar' : 'Crear' }} Rol</shared-title>
    <button
      mat-icon-button
      matTooltip="Limpiar formulario"
      matTooltipPosition="right"
      class="ml-5"
      (click)="clearForm()">
      <mat-icon>cleaning_services</mat-icon>
    </button>
  </mat-card-header>
  <form [formGroup]="roleForm">
    <mat-dialog-content>
      <div
        class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
        <shared-input
          class="w-full"
          [labelTitle]="'Nombre'"
          [control]="$any(roleForm.get('name'))" />

        <shared-input
          class="w-full"
          [labelTitle]="'Código'"
          [styleText]="'uppercase'"
          [control]="$any(roleForm.get('code'))" />
      </div>

      <div
        class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Recurrencia</mat-label>
          <input
            matInput
            formControlName="recurrence"
            type="number"
            #inp
            (change)="onChangeInput(inp)" />
          @if (roleForm.controls['recurrence'].hasError('required')) {
            <mat-error>
              <small>Número es <strong>requerido</strong> </small>
            </mat-error>
          }
          @if (roleForm.controls['recurrence'].hasError('min')) {
            <mat-error>
              <small><strong>Solo numeros</strong> </small>
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Tipo</mat-label>
          <mat-select formControlName="type">
            <mat-option value="application"> aplicación </mat-option>
            <mat-option value="web"> web </mat-option>
          </mat-select>
          @if (roleForm.controls['type'].hasError('required')) {
            <mat-error>
              <small>Tipo es <strong>requerido</strong> </small>
            </mat-error>
          }
        </mat-form-field>
      </div>
      <shared-input
        [labelTitle]="'Descripción'"
        [control]="$any(roleForm.get('description'))" />
    </mat-dialog-content>

    <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
      <shared-button
        mat-dialog-close
        [icon]="'clear'"
        [typeBtn]="'button'"
        [color]="'warn'"
        >Cancelar</shared-button
      >

      <shared-button
        [disabled]="!roleForm.valid"
        [icon]="'save_alt'"
        [typeBtn]="'submit'"
        [color]="'accent'"
        (click)="submit()"
        mat-dialog-close="true"
        >Guardar</shared-button
      >
    </mat-dialog-actions>
  </form>
</div>
